import { forwardRef, type InputHTMLAttributes } from 'react'

import { cn } from '@/utils/cn'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label: string
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { label, className, id, ...props },
  ref,
) {
  return (
    <label
      htmlFor={id}
      className={cn('flex cursor-pointer select-none items-center gap-2', className)}
    >
      <input
        ref={ref}
        id={id}
        type="checkbox"
        className="size-4 rounded border-line text-brand accent-brand focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand"
        {...props}
      />
      <span className="text-sm text-fg">{label}</span>
    </label>
  )
})
